export default __webpack_public_path__ + "static/media/matthew_chan.6b694088.jpg";